import { Link } from 'react-router-dom';
import { SupportIcon } from '../assets/svgImages';
import { useContext } from 'react';
import { UserContext } from '../context/userContext';
import ContactModal from '../views/ContactModal';

function FloatingContact() {
  const { isMobile } = useContext(UserContext);
  const contactLink = isMobile
    ? '/contact'
    : 'https://monivearoad.com.au/contact-us/';

  return (
    <div>
      {isMobile ? (
        <ContactModal />
      ) : (
        <Link to={contactLink}>
          <div className="fixed bottom-[13%] right-[5%] w-[50px] h-[50px] bg-primary-blue-500 rounded-full z-[9999] flex items-center justify-center">
            <SupportIcon className="w-[20px] h-[20px]" />
          </div>
        </Link>
      )}
    </div>
  );
}
export default FloatingContact;
